// removed by extract-text-webpack-plugin
module.exports = {"Game":"index__Game___UBSuj","scrollWrapper":"index__scrollWrapper___3F52W","iPadWrapper":"index__iPadWrapper___2nZXc","androidWrapper":"index__androidWrapper___9pxvl","scrolWrapper":"index__scrolWrapper___38EUj"};


//////////////////
// WEBPACK FOOTER
// ./src/game/index.scss
// module id = ./src/game/index.scss
// module chunks = 1